var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scratchHome"},[_c('div',{staticClass:"items"},_vm._l((_vm.data),function(item){return _c('div',{key:item.pk,staticClass:"item"},[_c('ActivityItem',{attrs:{"dic":item}}),_c('div',{attrs:{"id":"line"}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }